import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

// Import Setting Service and User, Credential Model
import { SettingService } from './SettingService';
import { ApiService } from './ApiService';

@Injectable()
export class FileService {
    private fileUrl = '/files';
    private apiUrl = '';

    constructor (
        private settingService: SettingService,
        private apiService: ApiService
    ) {
        this.apiUrl = this.settingService.getSetting('api_service_domain');
    }

    uploadFile(data: FormData): Observable<any> {
        const requestUrl = this.apiUrl + this.fileUrl;

        return this.apiService.post(requestUrl, data);
    }    

    getFile(fileId: string)  {
         return this.apiUrl + this.fileUrl + '/' + fileId;
    }    
}


// WEBPACK FOOTER //
// ./src/common/modules/core/services/FileService.ts